"use client";

import { closeModal, openModal } from "@/redux/popup/modalSlice";
import { useSession } from "next-auth/react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Label } from "@radix-ui/react-dropdown-menu";
import { Input } from "../ui/input";
import moment from "moment";
import { useParams } from "next/navigation";
import Numflag from "./Mob_nflag";
import { Button } from "../ui/button";
import { decrementTravelCount, incrementTravelCount } from "@/redux/checkout/travelCount";
import Image from "next/image";
import { apiFetch } from "@/lib/ftv-api/api-ftv";
import Payment from "@/app/[locale]/payment/page";
const TravelerInfo = () => {
  const {
    data: session,
    status
  } = useSession();
  const params = useParams();
  const {
    locale,
    checkout_in
  } = params;
  const pageUrl = checkout_in;
  const dispatch = useDispatch();
  const [errorMsg, seterrorMsg] = useState(null);
  const currentUser = useSelector(s => s.currentUser.currentUser);
  const checkoutPage = useSelector(s_0 => s_0.checkoutPage.checkoutData);
  const couponCode = useSelector(s_1 => s_1.checkoutPage.couponCode);
  const couponAmount = useSelector(s_2 => s_2.checkoutPage.couponAmount);
  const travelCount = useSelector(s_3 => s_3.travel.travelCount);
  const [paymentData, setPaymentData] = useState({});
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const REQUIRED_FIELDS = ["first_name", "last_name", "email", "phone_Number", "city", "address"];
  const [travelerInfo, setTravelerInfo] = useState([{
    first_name: "",
    last_name: "",
    email: "",
    phone_Number: "",
    city: "",
    address: "",
    errors: {}
  }]);
  useEffect(() => {
    if (!session && status !== "loading") {
      dispatch(openModal());
    }
  }, [session, status, dispatch]);
  useEffect(() => {
    if (!currentUser) {
      setTravelerInfo([{
        first_name: "",
        last_name: "",
        email: "",
        phone_Number: "",
        city: "",
        address: "",
        errors: {}
      }]);
      return;
    }
    dispatch(closeModal());
    const fullName = currentUser?.name_of_agency?.split(" ") || [];
    const firstName = fullName[0] || "";
    const lastName = fullName.slice(1).join(" ");
    setTravelerInfo([{
      first_name: firstName,
      last_name: lastName,
      email: currentUser?.email || "",
      phone_Number: currentUser?.mobile_number || "",
      city: currentUser?.city || "",
      address: currentUser?.address || "",
      errors: {}
    }]);
  }, [currentUser, dispatch]);
  const handleChange = (index, event) => {
    const {
      name,
      value
    } = event.target;
    const updatedTravelers = [...travelerInfo];
    let formattedValue = value;
    if (name === "phone_Number") {
      formattedValue = value.replace(/\D/g, "").slice(0, 10);
    }
    updatedTravelers[index] = {
      ...updatedTravelers[index],
      [name]: formattedValue,
      errors: {
        ...updatedTravelers[index].errors,
        [name]: !formattedValue.trim() ? "This field is required" : ""
      }
    };
    setTravelerInfo(updatedTravelers);
  };
  const validateTravelers = travelers => {
    let isValid = true;
    const updated = travelers.map(traveler => {
      const errors = {};
      REQUIRED_FIELDS.forEach(field => {
        const value_0 = traveler[field];
        if (value_0 === undefined || value_0 === null || String(value_0).trim() === "") {
          errors[field] = "This field is required";
          isValid = false;
        }
      });
      return {
        ...traveler,
        errors
      };
    });
    return {
      isValid,
      updated
    };
  };
  const addFormFields = e => {
    e.preventDefault();
    if (!currentUser) {
      dispatch(openModal());
      return;
    }
    const {
      isValid: isValid_0,
      updated: updated_0
    } = validateTravelers(travelerInfo);
    setTravelerInfo(updated_0);
    if (!isValid_0) return;
    if (travelerInfo.length >= 5) return;
    setTravelerInfo([...updated_0, {
      first_name: "",
      last_name: "",
      email: "",
      phone_Number: "",
      city: "",
      address: "",
      errors: {}
    }]);
    dispatch(incrementTravelCount(travelerInfo.length));
  };
  const removeTraveler = index_0 => {
    if (index_0 === 0) return;
    setTravelerInfo(travelerInfo.filter((_, i) => i !== index_0));
    dispatch(decrementTravelCount(travelerInfo.length));
  };
  const submitTravelInfo = async e_0 => {
    e_0.preventDefault();
    if (!currentUser) {
      dispatch(openModal());
      return;
    }
    const {
      isValid: isValid_1,
      updated: updated_1
    } = validateTravelers(travelerInfo);
    setTravelerInfo(updated_1);
    if (!isValid_1) {
      console.log("Validation failed");
      return;
    }
    const {
      price = 0,
      currency_code,
      country_site,
      country,
      coupon_code_discount = 0,
      embassey_fee = 0
    } = checkoutPage?.[0] || [];
    const total_amount = couponAmount > 0 && checkoutPage.length > 0 ? Math.round(embassey_fee * travelCount + (price - embassey_fee) * travelCount - couponAmount) : price;
    const data = new FormData();
    data.append("id", pageUrl);
    data.append("no_of_pax", travelCount);
    data.append("total_amount", total_amount * travelCount);
    data.append("coupon_code", couponCode);
    data.append("discount_price", Math.round(coupon_code_discount / 100 * (price - embassey_fee) * travelCount));
    data.append("destination", country);
    data.append("user_id", currentUser?.id);
    travelerInfo.forEach(({
      first_name,
      last_name,
      email,
      phone_Number,
      Arrival,
      Departure,
      city,
      address
    }) => {
      data.append("fname[]", first_name);
      data.append("lname[]", last_name);
      data.append("origin[]", country_site);
      data.append("citizen_of", country_site);
      data.append("email_id[]", email);
      data.append("phone[]", phone_Number);
      data.append("d_o_a[]", moment(Arrival).format("DD/MM/yyyy"));
      data.append("d_o_t[]", moment(Departure).format("DD/MM/yyyy"));
      data.append("city[]", city);
      data.append("address[]", address);
    });
    // for (let pair of data.entries()) {
    //   console.log(pair[0] + ": " + pair[1]);
    // }
    try {
      const res = await apiFetch(`/api/${locale}/success`, {
        method: "POST",
        body: data,
        cache: "no-store"
      });
      const total_amount_vp = checkoutPage?.[0].price;
      const order_id = res.order_id;
      const ProductId = pageUrl;
      const cId = locale;
      const user_id = currentUser?.id;
      const propPayentData = {
        finalAmount: total_amount * travelCount,
        visaPrice: couponAmount > 0 ? total_amount : total_amount_vp * travelCount,
        currency: checkoutPage?.[0].currency_code,
        ProductId: pageUrl,
        order_id: order_id,
        email: currentUser?.email,
        cId: locale
      };
      // console.log(propPayentData);
      setPaymentData(propPayentData);
      OpenPaymentPopup();
    } catch (error) {}
  };
  const OpenPaymentPopup = () => {
    setShowPaymentModal(true);
  };
  const ClosePaymentPopup = () => {
    setShowPaymentModal(false);
  };
  return <>
      <form>
        {travelerInfo.map((traveler_0, index_1) => <div key={index_1}>
            <h2 className={`font-semibold text-primary/85 font-geistSans tracking-wider flex justify-between items-center ${index_1 > 0 ? "mt-6" : ""}`}>
              Traveler Information {index_1 + 1}
              {index_1 > 0 && <Button type="button" variant="destructive" className="px-3 py-1" onClick={() => removeTraveler(index_1)}>
                  Remove
                </Button>}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <div className="ftv-field mt-5">
                  <Label htmlFor={`first_name${index_1}`} className="pl-1 text-xs">
                    First Name <span className="text-rose-700">*</span>
                  </Label>
                  <Input id={`first_name${index_1}`} className="border-transparent shadow-none pl-1" name="first_name" value={traveler_0.first_name} onChange={event_0 => handleChange(index_1, event_0)} />
                </div>
                {traveler_0.errors.first_name && <span className="text-xs font-normal tracking-wide text-rose-500">
                    {traveler_0.errors.first_name}
                  </span>}
              </div>
              <div>
                <div className="ftv-field mt-5">
                  <Label htmlFor={`last_name${index_1}`} className="pl-1 text-xs">
                    Last Name <span className="text-rose-700">*</span>
                  </Label>
                  <Input id={`last_name${index_1}`} className="border-transparent shadow-none pl-1" name="last_name" value={traveler_0.last_name} onChange={event_1 => handleChange(index_1, event_1)} />
                </div>
                {traveler_0.errors.last_name && <span className="text-xs font-normal tracking-wide text-rose-500">
                    {traveler_0.errors.last_name}
                  </span>}
              </div>
              <h3 className="font-semibold text-primary/85">Contact</h3>
              <p></p>
              <div>
                <div className="ftv-field mt-0 relative">
                  <Label htmlFor={`phone${index_1}`} className="pl-1 text-xs">
                    Phone Number <span className="text-rose-700">*</span>
                  </Label>
                  <Numflag country_ext={locale}></Numflag>
                  <Input className="border-transparent shadow-none pl-11" id={`phone${index_1}`} type="tel" maxLength="10" name="phone_Number" value={traveler_0.phone_Number} onChange={event_2 => handleChange(index_1, event_2)} />
                </div>
                {traveler_0.errors.phone_Number && <span className="text-xs font-normal tracking-wide text-red-600">
                    {traveler_0.errors.phone_Number}
                  </span>}
              </div>
              <div>
                <div className="ftv-field mt-0">
                  <Label className="pl-1 text-xs" htmlFor={`email${index_1}`}>
                    Email <span className="text-rose-700">*</span>
                  </Label>
                  <Input className="border-transparent shadow-none pl-1" id={`email${index_1}`} type="email" name="email" value={traveler_0.email} onChange={event_3 => handleChange(index_1, event_3)} />
                </div>
                {traveler_0.errors.email && <span className="text-xs font-normal tracking-wide text-red-600">
                    {traveler_0.errors.email}
                  </span>}
              </div>
              <div>
                <div className="ftv-field mt-0">
                  <Label className="pl-1 text-xs" htmlFor={`city${index_1}`}>
                    City <span className="text-rose-700">*</span>
                  </Label>
                  <Input className="border-transparent shadow-none pl-1" id={`city${index_1}`} type="text" name="city" value={traveler_0.city} onChange={event_4 => handleChange(index_1, event_4)} />
                </div>
                {traveler_0.errors.city && <span className="text-xs font-normal tracking-wide text-red-600">
                    {traveler_0.errors.city}
                  </span>}
              </div>
              <div>
                <div className="ftv-field mt-0">
                  <Label htmlFor={`nationality${index_1}`} className="pl-1 text-xs">
                    Nationality <span className="text-rose-700">*</span>
                  </Label>
                  <Input className="border-transparent shadow-none pl-1" id={`nationality${index_1}`} type="text" name="address" value={traveler_0.address} onChange={event_5 => handleChange(index_1, event_5)} />
                </div>
                {traveler_0.errors.address && <span className="text-xs font-normal tracking-wide text-red-600">
                    {traveler_0.errors.address}
                  </span>}
              </div>
            </div>
          </div>)}
        {travelerInfo.length < 5 ? <Button type="button" onClick={addFormFields} className="w-full mt-10 h-12 hover:bg-destructive/90 hover:text-white text-[16px]" variant="outline">
            + Add Traveller
          </Button> : <Button className="w-full mt-10 h-12 hover:bg-destructive/90 hover:text-white text-[16px] cursor-pointer" type="button" disabled>
            Max 5 Travellers
          </Button>}
        <Button className="w-full mt-8 h-12 text-[16px] cursor-pointer" type="button" variant="destructive" onClick={submitTravelInfo}>
          Continue to Payment
        </Button>
        <div className="mt-8 w-3/4 md:w-1/2  h-20 relative mx-auto">
          <Image src="/assets/img/secure-stripe-payment.png" alt="secure-stripe-payment" width={500} height={250} className="w-full h-auto" style={{
          objectFit: "contain"
        }} />
        </div>
      </form>

       {showPaymentModal && <Payment paymentData={paymentData} ClosePaymentPopup={ClosePaymentPopup} />}
    </>;
};
export default TravelerInfo;